import {Link, LinkProps} from 'react-router';
import clsx from 'clsx';
import React, {ReactNode, useMemo} from 'react';
import {slugifyString} from '@ui/utils/string/slugify-string';
import {Person} from '@app/titles/models/person';
import {getBaseMediaLink} from '@app/base-media-link';
import {getPersonDisplayName} from '@app/people/person-display-name';

interface Props extends Omit<LinkProps, 'to'> {
  person: Person;
  className?: string;
  children?: ReactNode;
  color?: 'primary' | 'inherit';
}
export function PersonLink({
  person,
  className,
  children,
  color = 'inherit',
  ...linkProps
}: Props) {
  const finalUri = useMemo(() => {
    return getPersonLink(person);
  }, [person]);

  return (
    <Link
      {...linkProps}
      className={clsx(
        color === 'primary'
          ? 'text-primary hover:text-primary-dark'
          : 'text-inherit',
        'overflow-x-hidden overflow-ellipsis outline-none transition-colors hover:underline focus-visible:underline',
        className,
      )}
      to={finalUri}
    >
      {children ?? getPersonDisplayName(person)}
    </Link>
  );
}

export function getPersonLink(
  person: Person,
  {absolute}: {absolute?: boolean} = {},
): string {
  // Build the TR-segment path; getBaseMediaLink translates it to the active
  // locale (B19, Day 29) and applies the absolute base_url when requested.
  const link = person.slug
    ? `/tr/kisi/${person.slug}`
    : `/tr/kisi/kisi-${person.id}`;
  return getBaseMediaLink(link, {absolute});
}
